import { EvoModel } from '../evo-model';

export class CreateOrganization extends EvoModel {

	public name: string;
	public logoUrl: string;
	public alias: string;
	public sizeRange: string;
	public department: string;

	public products: any[];
}
